<template>
  <div>
    <DxButton
      width="100%"
      text="SAVE"
      type="success"
      styling-mode="contained"
      @click="onClick($event)"
      :validation-group="validationGroup"
    />
  </div>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function,
      required: true
    },
    validationGroup: {
      type: String,
      default: () => {
        return "formsData";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>